import React, { useState } from "react"
import { Row, Col } from "react-bootstrap"
import Accordion from "react-bootstrap/Accordion"
import { useAccordionButton } from "react-bootstrap/AccordionButton"
import { StructuredText } from "react-datocms"

import playBtn from "../../../images/PlaySolid.svg"
import { ArrowDown } from "../../../utils/IconsList"
import Heading from "../../../utils/OptimizedHeading"
import Img from "../../../utils/OptimizedImage"
import VideoModal from "../../Modal/VideoModal/VideoModal"

const StandardContent = ({
  item,
  idx,
  selected,
  setSelected,
  activeSlideIndex,
}) => {
  const [play, setPlay] = useState(false)
  const playVideo = () => {
    setPlay(true)
  }

  const CustomToggle = ({ record, eventKey }) => {
    const decoratedOnClick = useAccordionButton(eventKey, () =>
      selected !== record?.heading
        ? setSelected(record?.heading)
        : setSelected(null)
    )

    return (
      <button type="button" onClick={decoratedOnClick}>
        <span>{record.heading}</span>
        <span
          className={`arrowIcon ${
            selected === record.heading ? "expanded" : ""
          }`}
        >
          <ArrowDown className="align-middle mr-1" />
        </span>
      </button>
    )
  }

  return (
    <div
      key={idx}
      className={idx === activeSlideIndex ? "active-slide" : "inactive"}
    >
      <Row className="slide-desc">
        <Col lg={7}>
          {item?.label && (
            <Heading
              type={item?.headingSize}
              string={item?.heading}
              className="heading"
            />
          )}
          <StructuredText
            data={item?.body}
            renderInlineRecord={({ record }) => {
              return (
                <Accordion>
                  <CustomToggle record={record} eventKey={record?.idx} />
                  <Accordion.Collapse eventKey={record?.idx}>
                    <div className="my-2">
                      <StructuredText data={record?.body} />
                    </div>
                  </Accordion.Collapse>
                </Accordion>
              )
            }}
          />
        </Col>
        <Col lg={5} className="d-flex align-items-center text-center">
          {item?.reference?.model?.apiKey === "component_image" && (
            <div
              style={{
                maxWidth: item?.reference?.desktop?.width + "px",
                margin: "0 auto",
              }}
            >
              <Img
                src={item?.reference?.desktop?.url}
                msrc={item?.reference?.mobile?.url}
                alt={item?.reference?.desktop?.title}
                mfluid={item?.reference?.mobile?.fluid}
                fluid={item?.reference?.desktop?.fluid}
                width={item?.reference?.desktop?.width}
                height={item?.reference?.desktop?.height}
                fadeIn={false}
                className="slideImg"
              />
            </div>
          )}
          {item?.reference?.model?.apiKey === "component_video" && (
            <div className="slide-video">
              <div className="slide-video-img">
                <Img
                  src={item?.reference?.thumbnail?.url}
                  alt={item?.reference?.thumbnail?.title}
                  fluid={item?.reference?.thumbnail?.fluid}
                  fadeIn={false}
                  width={item?.reference?.thumbnail?.width}
                  height={item?.reference?.thumbnail?.height}
                />
              </div>
              <div className="playicon">
                <span onClick={() => playVideo()}>
                  <Img src={playBtn} alt="Play Button" />
                </span>
              </div>
              {item?.reference?.model?.apiKey === "component_video" && (
                <VideoModal
                  play={play}
                  setPlay={setPlay}
                  component={item?.reference}
                />
              )}
            </div>
          )}
        </Col>
      </Row>
    </div>
  )
}

export default StandardContent
